import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import setNullEmptyValues from 'common/util/setNullEmptyValues';

import {
  SR_API_ACTION_FINANCES_CREATE_MERCHANT,
} from 'api/actionTypes';

import ButtonDeprecated, {
  BUTTON_THEME_YELLOW,
} from 'client/components/ButtonDeprecated';
import SrFormikField from 'client/components/SrFormikField';

import branch from 'client/core/branch';
import log from 'client/lib/log';
import {
  createFormValidationFn,
  createInitialValues,
} from 'client/helpers/formikHelpers';
import withApiState from 'client/helpers/withApiState';
import postWithState from 'client/actions/postWithState';

const createMerchantFormFields = [
  {
    id: 'displayName',
    title: 'Display Name',
    type: 'short_text',
    properties: {
      placeholder: 'ACME Inc.',
    },
    validations: ['required'],
  },
  {
    id: 'invoiceEmail',
    title: 'Invoicing Email',
    type: 'email',
    validations: ['required', 'email'],
    properties: {
      placeholder: 'invoices@acme.com',
    },
  },
  {
    id: 'invoicePhone',
    title: 'Invoicing Phone',
    type: 'phone',
    validations: ['required', 'phone'],
  },
  {
    id: 'vendorRegistrationNumber',
    title: 'Vendor Registration Number',
    label: 'The vendor registration number (optional)',
    type: 'short_text',
  },
];

@withApiState({
  createMerchantApiState: {
    action: SR_API_ACTION_FINANCES_CREATE_MERCHANT,
  },
})
@branch()
class SrCreateMerchantForm extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    onMerchantCreated: PropTypes.func,
    createMerchantApiState: PropTypes.object.isRequired,
  }

  _onSubmitForm = (values) => {
    const { dispatch, onMerchantCreated } = this.props;

    dispatch(postWithState, {
      action: SR_API_ACTION_FINANCES_CREATE_MERCHANT,
      payload: setNullEmptyValues(values),
    })
      .then((merchant) => {
        if (onMerchantCreated) {
          return onMerchantCreated(merchant);
        }
      })
      .catch((error) => {
        log.error(error);
      });
  }

  render() {
    const {
      createMerchantApiState,
    } = this.props;

    if (createMerchantApiState.inProgress) {
      return (
        <div className='loading-gif' />
      );
    }

    const initialValues = createInitialValues({
      formFields: createMerchantFormFields,
    });

    return (
      <div className='formContainer'>
        {createMerchantApiState.error && (
          <div className='mainMessage formMessage error'>
            <span>{createMerchantApiState.error.message}</span>
          </div>
        )}
        <Formik
          enableReinitialize
          initialValues={initialValues}
          validate={createFormValidationFn(createMerchantFormFields)}
          onSubmit={this._onSubmitForm}
          render={(formikBag) => (
            <Form>
              {createMerchantFormFields.map((formField) => (
                <SrFormikField
                  key={formField.id}
                  formField={formField}
                  formikBag={formikBag}
                />
              ))}
              <div className='bottomActionsContainer'>
                <ButtonDeprecated
                  theme={BUTTON_THEME_YELLOW}
                  type='submit'
                >
                  {createMerchantApiState.inProgress
                    ? 'please wait...'
                    : 'create merchant'
                  }
                </ButtonDeprecated>
              </div>
            </Form>
          )}
        />
      </div>
    );
  }
}

SrCreateMerchantForm.displayName = 'SrCreateMerchantForm';

export default SrCreateMerchantForm;
